// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.errorMessage {
  font-size: 12px;
  color: #CC0101;
}
`, "",{"version":3,"sources":["webpack://./src/app/Controls/Core/CollectionViewBox.less"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,cAAA;AADF","sourcesContent":["@import '~common-controls/Style/Colors.less';\n\n.errorMessage {\n  font-size: 12px;\n  color: @error-color;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
